
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

// Import images from local assets folder
import american from "./assets/feature/ex_airline_logo.svg";
import delta from "./assets/feature/delta_airline_logo_DL.svg";
import virgin from "./assets/feature/vj_airline_logo_VS.svg";
import lufthansa from "./assets/feature/Lu_airline_logo_LH.svg";
import british from "./assets/feature/British_airline_logo.svg";
import united from "./assets/feature/united_airline_logo_UA.svg";
import airfrance from "./assets/feature/air_airline_logo_AF.svg";
import turkish from "./assets/feature/tk_airline_logo.svg";

const airlines = [
  { name: "American Airlines", logo: american },
  { name: "Delta", logo: delta },
  { name: "Virgin Atlantic", logo: virgin },
  { name: "Lufthansa", logo: lufthansa },
  { name: "British Airways", logo: british },
  { name: "United Airlines", logo: united },
  { name: "Air France", logo: airfrance },
  { name: "Turkish Airlines", logo: turkish },
];

const FeaturedAirlines = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    pauseOnHover: false,
    cssEase: "linear",
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="bg-lightblue py-5">
      <div className="container w-auto">
        <h2 className="text-dark fw-bold text-center mb-4">Featured Airlines</h2>
        <div className="p-3 bg-white rounded shadow-sm">
          <Slider {...settings}>
            {airlines.map((airline, index) => (
              <div key={index} className="text-center">
                <img
                  src={airline.logo}
                  alt={airline.name}
                  className="airline-logo"
                  style={{ height: "120px", width: "170px", objectFit: "contain" }}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default FeaturedAirlines;
